import { render } from "./RequestNotes.vue?vue&type=template&id=1c228c79"
import script from "./RequestNotes.vue?vue&type=script&lang=js"
export * from "./RequestNotes.vue?vue&type=script&lang=js"

import "./RequestNotes.vue?vue&type=style&index=0&id=1c228c79&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__